// import { isBrowser } from '@jarvis.oddle/core/env'
import { createModalFlow } from 'src/utils/flow'

export const flowConfig = {
  initial: 'entry',
  states: {
    entry: {
      on: {
        initial: 'PickupDeliverySelectionModal',
        pickupStoreSelection: 'PickupStoreSelectionModal',
        deliverySelectAddress: 'DeliverySelectAddressModal',
        dateTimeSelection: 'DateTimeSelectionModal'
      }
    },
    exit: {},
    finish: {},
    PickupDeliverySelectionModal: {
      on: {
        pickupStoreSelection: 'PickupStoreSelectionModal',
        deliverySelectAddress: 'DeliverySelectAddressModal',
        dateTimeSelection: 'DateTimeSelectionModal',
        finish: 'finish'
      }
    },
    PickupStoreSelectionModal: {
      on: {
        prev: 'PickupDeliverySelectionModal',
        dateTimeSelection: 'DateTimeSelectionModal'
      }
    },
    DeliverySelectAddressModal: {
      on: {
        prev: 'PickupDeliverySelectionModal',
        dateTimeSelection: 'DateTimeSelectionModal'
      }
    },
    DateTimeSelectionModal: {
      on: {
        prev: [
          {
            target: 'PickupStoreSelectionModal',
            cond: (_, { data }) => data.isPickup
          },
          {
            target: 'DeliverySelectAddressModal'
          }
        ],
        finish: 'finish'
      }
    }
  }
}

const pickupDeliveryFlow = createModalFlow(flowConfig)

// NOTE
// This is not in use due to OMS bug and API limitation
// Track here: https://oddle-pm.atlassian.net/browse/OMS-2436

// // WORKAROUND: isVisited is set using 'method' stored in localStorage.
// // This's because we want to persist isVisited state for pickupDeliveryFlow when users refresh the page.
// // NOTE: updateMeta should be a flow's internal method. This's only used here as a workaround.
// if (isBrowser()) {
//   pickupDeliveryFlow.updateMeta({
//     isVisited: window.localStorage.getItem('method') !== null &&
//       window.localStorage.getItem('collectionDate') !== null &&
//       window.localStorage.getItem('collectionTime') !== null
//   })
// }

export default pickupDeliveryFlow
